// Google Analytics 4 utility functions
// Dynamically loads GA4 script and initializes tracking

// GA4 Measurement ID - hardcoded
export const GA_MEASUREMENT_ID = 'G-8F99EDVLPS';

type GtagParams = Record<string, unknown>;

//console.log('Analytics module loaded! GA ID: ' + GA_MEASUREMENT_ID);

// Debug: Log the measurement ID to console with prominent styling
//console.error('🔍 ANALYTICS MODULE LOADED - GA_MEASUREMENT_ID:', GA_MEASUREMENT_ID);
//console.error('🔍 ANALYTICS MODULE LOADED - Hardcoded GA ID:', GA_MEASUREMENT_ID);
//alert('Analytics module loaded! GA ID: ' + GA_MEASUREMENT_ID);

// Load Google Analytics script dynamically
const loadGAScript = () => {
  if (typeof window === 'undefined' || !GA_MEASUREMENT_ID) {
    return;
  }

  // Create and load the gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8F99EDVLPS';
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => {
    window.dataLayer.push(args);
  };

  // Initialize with current date
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    debug_mode: true, // Enable debug mode for testing
  });
};

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined') {
    // Load GA script if not already loaded
    if (!window.gtag) {
      loadGAScript();
    } else {
      // If already loaded, just configure
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_title: document.title,
        page_location: window.location.href,
      });
    }
  }
};

// Track page views
export const trackPageView = (path: string, title: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (
  action: string,
  category: string,
  label: string,
  value?: string | number | boolean
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track conversions (purchases, sign-ups, etc.)
export const trackConversion = (eventName: string, parameters: GtagParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      currency: 'USD',
      ...parameters,
    });
  }
};

// Track purchase events (for your PayPal integration)
export const trackPurchase = (
  transactionId: string,
  value: number,
  currency = 'USD',
  items: unknown[] = []
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: items,
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('click', 'button', `${buttonName}_${location}`);
};

// Track form submissions
export const trackFormSubmit = (formName: string) => {
  trackEvent('submit', 'form', formName);
};
